namespace TabAurous.OMS {
    export interface OrderStatusForm {
        AttributeCode: Serenity.StringEditor;
        AttributeName: Serenity.StringEditor;
    }

    export class OrderStatusForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.OrderStatus';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!OrderStatusForm.init)  {
                OrderStatusForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(OrderStatusForm, [
                    'AttributeCode', w0,
                    'AttributeName', w0
                ]);
            }
        }
    }
}
